import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContainerModel } from '@app/models/server/layout.model';
import { TitleCasePipe } from '@angular/common';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { B2bDragScrollComponent } from '@app/new-ui-lib/b2b-drag-scroll/b2b-drag-scroll/b2b-drag-scroll.component';
import { B2bDragScrollItemComponent } from '@app/new-ui-lib/b2b-drag-scroll/b2b-drag-scroll-item/b2b-drag-scroll-item.component';
import { DragScrollType } from '@app/models/client/drag-scroll.type';

@Component({
  selector: 'app-b2b-new-tabs',
  templateUrl: './b2b-new-tabs.component.html',
  styleUrls: ['./b2b-new-tabs.component.scss'],
  standalone: true,
  imports: [TitleCasePipe, B2bDragScrollComponent, B2bDragScrollItemComponent],
})
export class B2bNewTabsComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };

  selectedTab: ContainerModel;

  isDesktop: boolean = this.b2bDeviceUtilService.isDesktop();

  @Output() changeTab: EventEmitter<ContainerModel> = new EventEmitter();
  swiperConfig: DragScrollType = {
    autoHeight: true,
    spaceBetween: 0,
    navigation: false,
    freeMode: false,
    mousewheel: false,
    grabCursor: false,
    pagination: true,
    slidesPerView: 3.5,
    centeredSlides: false,
    injectStyles: [],
    hideScrollButtons: false,
    showAbsoluteButtons: false,
  };

  constructor(private b2bDeviceUtilService: B2bDeviceUtilService) {}

  ngOnInit() {
    if (this.compData?.container?.containers?.length > 0) {
      this.selectedTab = this.compData?.container?.containers[0];
    }
  }

  onTab(item: ContainerModel) {
    this.selectedTab = item;
    this.changeTab.emit(this.selectedTab);
  }
}
